'use strict'
import EventEmitter from './EventEmitter.js'

export default class Sizes extends EventEmitter
{
  constructor()
  {
    super()

    // Setup
    this.width = window.innerWidth
    this.height = window.innerHeight
    this.pixelRatio = Math.min(window.devicePixelRatio, 2)

    // Resize
    this.resize()
  }
  // Resize
  resize()
  {
    window.addEventListener('resize', () =>
    {
      // Update sizes
      this.width = window.innerWidth
      this.height = window.innerHeight
      this.pixelRatio = Math.min(window.devicePixelRatio, 2)
      // Trigger
      this.trigger('resize')
    })
  }
}